import Markdown from '#src/components/MarkdownWithHtml';
import {
  flattenImageAsset,
  selectFields,
} from '#src/lib/contentful/selectors.mjs';
import { CloudinaryImage } from '#src/components/CloudinaryImage';
import Container from '#src/components/Container';
import CardGroup from '#src/components/CardGroup';

import styles from './WaybetterWay.scss';
import { Card } from './Card';

export function WaybetterWay({
  title,
  headline,
  diagram,
  ways = [],
  exitCallout,
}) {
  return (
    <Container className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <Markdown className={styles.content}>{headline}</Markdown>
      <CloudinaryImage
        {...flattenImageAsset(diagram)}
        className={styles.diagram}
      />
      <CardGroup className={styles.ways}>
        {ways.map((way) => (
          <Card key={way.fields.title} {...selectFields(way)} />
        ))}
      </CardGroup>
      <Markdown className={styles.exit}>{exitCallout}</Markdown>
    </Container>
  );
}
